import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ArkUnitOfWork, AppInformationService } from 'app/core/core.module';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { confirm, alert } from 'devextreme/ui/dialog';
import { ContributionLine, Contribution } from 'app/core/model/entity-model';
import { CashListComponent } from '../cash-list/cash-list.component';
import _ from 'lodash';
import { DevExtremeModule } from 'devextreme-angular';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-contribution-edit-dialog',
    templateUrl: './contribution-edit-dialog.component.html',
    styleUrls: ['./contribution-edit-dialog.component.scss'],
    imports: [CommonModule, FormsModule, DevExtremeModule, CurrencyPipe],
    standalone: true,
})
export class ContributionEditDialogComponent implements OnInit {
    result: Subject<boolean> = new Subject<boolean>();
    contribution: Contribution;
    people: any[];
    types: any[];
    otherAccounts: any[];
    readonly = false;
    contributionId: any;
    totalEntered: number;
    hideCash = true;
    batchId: number;
    specialAccountId: number;
    processing = false;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private modalService: BsModalService, public appInfo: AppInformationService) {}

    async ngOnInit() {
        this.people = (await this.uow.getPeopleForGiving()).slice();
        const found = _(this.people).some({ id: this.contribution.personId } as any);
        if (!found) this.people.unshift(this.contribution.person.getPersonInfo());

        this.types = this.uow.getContributionTypes();
        this.otherAccounts = this.uow.otherAccounts().slice();

        this.contribution.lines.forEach(l => (l.allowSelect = false));

        const includeAccounts = this.uow.includeAccounts();
        _(includeAccounts).forEachRight((account: any) => {
            if (_(this.contribution.lines).some({ accountId: account.id })) return;

            this.otherAccounts.unshift(account);
        });

        this.totalEntered = this.contribution.totalAmount;
    }

    addLine() {
        const line: any = this.uow.manager.createEntity('ContributionLine');
        line.allowSelect = true;
        this.contribution.lines.push(line);
    }

    async save() {
        if (this.processing) return;
        this.processing = true;
        _(this.contribution.lines).forEachRight(line => {
            if (!line.amount) line.entityAspect.setDeleted();
        });
        await this.uow.commit();
        this.result.next(true);
        this.modalRef.hide();
        this.processing = false;
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }

    async delete() {
        const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to delete this contribution?', 'Confirm Delete'));
        if (!dialogResult) return;
        if (this.contribution.cashCounts.length > 0) {
            _(this.contribution.cashCounts).forEachRight(cash => {
                cash.entityAspect.setDeleted();
            });
        }
        _(this.contribution.lines).forEachRight(line => {
            line.entityAspect.setDeleted();
        });
        this.contribution.entityAspect.setDeleted();
        await this.uow.commit();
        this.result.next(true);
        this.modalRef.hide();
    }

    async openCash() {
        let contributionCash = await this.uow.getBatchCashByContributionId(this.contribution.id);
        if (!contributionCash) {
            contributionCash = this.uow.manager.createEntity('ContributionCash', { contributionId: this.contribution.id });
        }

        const modalRef = this.modalService.show(CashListComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: { contributionCash: contributionCash, contribution: this.contribution, specialAccountId: this.specialAccountId }
        });

        modalRef.content.result.subscribe(async result => {
            if (result) {
                this.totalEntered = this.contribution.totalAmount;

                // await this.getBatch(this.contribution.batchId);
            }
        });
    }
}
